import logger from 'loglevel';
/**
 * Wrapper around a loglevel logger instance.
 *
 * Includes support for log handlers for all log levels for executing app-specific logging side effects.
 */
export class Logger {
    loggedMessages = new Set();
    instance;
    logHandlers = [];
    errorLogHandlers = [];
    constructor(logLevel = 'info') {
        logger.setLevel(logLevel);
        this.instance = logger;
    }
    logMessage(level, msg, context) {
        const logKey = `${msg}:${JSON.stringify(context)}`;
        if (!this.loggedMessages.has(logKey)) {
            const defaultContext = {
                level: level,
                timestamp: (new Date()).toLocaleString(),
            };
            const logMessage = {
                message: msg,
                ...defaultContext,
                ...context
            };
            // log message
            this.instance[level](logMessage);
            // add to logged messages to prevent duplicate logs
            this.loggedMessages.add(logKey);
            this.logHandlers
                .filter((handler) => handler.logLevels.includes(level))
                .forEach((handler) => handler.handle(msg, context));
        }
    }
    logError(error, context = {}) {
        const logKey = `${error.message}:${JSON.stringify(context)}`;
        if (!this.loggedMessages.has(logKey)) {
            const logMessage = {
                message: error.message,
                error: {
                    type: error.name,
                    stack: error.stack,
                },
                level: 'error',
                timestamp: (new Date()).toLocaleString(),
                ...context
            };
            // log message
            this.instance.error(logMessage);
            // add to logged messages to prevent duplicate logs
            this.loggedMessages.add(logKey);
            // execute error handlers
            this.errorLogHandlers.forEach((handler) => handler(error, context));
        }
    }
    debug(msg, context = {}) {
        this.logMessage('debug', msg, context);
    }
    info(msg, context = {}) {
        this.logMessage('info', msg, context);
    }
    warn(msg, context = {}) {
        this.logMessage('warn', msg, context);
    }
    error(error, context = {}) {
        this.logError(error, context);
    }
    addLogHandler(logLevels, handler) {
        this.logHandlers.push({ logLevels, handle: handler });
        return this;
    }
    addErrorLogHandler(handler) {
        this.errorLogHandlers.push(handler);
        return this;
    }
}
